import React, { ReactElement } from 'react'
import styles from './ScreenshotComposition.module.scss'
import { Screenshot } from '@/components/static/images/Screenshot/Screenshot'

interface CompositionImage {
    src: string
    alt: string
    // Full-size version for the click-to-expand preview. Supporting frames
    // are cropped thumbnails, so without this the expanded view is cut off.
    previewSrc?: string
}

interface ScreenshotCompositionProps {
    // The frame that carries the argument; rendered large.
    lead: CompositionImage
    // Shown side by side beneath the lead, smaller. One or two.
    supporting: CompositionImage[]
}

/**
 * One dominant screenshot with supporting frames beneath it, all visible at
 * once. Deliberately not a carousel: slides after the first get very little
 * attention, so hiding four fifths of the evidence behind arrows wastes it.
 */
export const ScreenshotComposition: React.FC<ScreenshotCompositionProps> = (
    props
): ReactElement => {
    return (
        <div className={styles.composition}>
            <div className={styles.lead}>
                <Screenshot
                    src={props.lead.src}
                    alt={props.lead.alt}
                    previewSrc={props.lead.previewSrc}
                />
            </div>
            <div className={styles.supporting}>
                {props.supporting.map((image) => (
                    <div className={styles.supportingItem} key={image.src}>
                        <Screenshot
                            src={image.src}
                            alt={image.alt}
                            previewSrc={image.previewSrc}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
